import { Injectable } from '@angular/core';
import { ICellularDeviceService } from './services';
import { ProxyService } from '../proxy/ProxyService';


@Injectable({
    providedIn: 'root'
})
export class CellularDeviceService implements ICellularDeviceService {
    public static $name: string = 'cellularDeviceService';

    private _devices: CASLink.Device.Ui.ViewModel.Modules.CellularDeviceTypeViewModel[];

    constructor(
        private proxyService: ProxyService
    ) {
    }

    public getCellularDevices(): angular.IPromise<CASLink.Device.Ui.ViewModel.Modules.CellularDeviceTypeViewModel[]> {
        if (this._devices) {
            return Promise.resolve(this._devices);
        } else {
            return this.initialize();
        }
    }

    private initialize(): angular.IPromise<CASLink.Device.Ui.ViewModel.Modules.CellularDeviceTypeViewModel[]> {
        return this.proxyService.request({
            endPoint: 'cellularDeviceType',
            route: 'getCellularDeviceTypes',
        }).asArray<CASLink.Device.Ui.ViewModel.Modules.CellularDeviceTypeViewModel>()
            .then((result: CASLink.Device.Ui.ViewModel.Modules.CellularDeviceTypeViewModel[]) => {
                this._devices = result;
                return result;
            });
    }
}
